import useGetUserProperties from "@/users/v3/useGetUserProperties";
import { isSupportedEnglishContent } from "@/utils/generatedContent";

import type { ContentLevel } from "@/types/models/ContentLevel.interface";
import type { ContentType } from "@/view/constants/contentTypes";
import type { Metadata } from "@/view/ContentHead";

/**
 * Hook to determine if the Lesson Planner feature should be visible to a user for a given content level.
 **/
const useLessonPlannerVisibility = ({
  articleType,
  currentLevel,
  contentMetadata = [],
  contentType,
}: {
  articleType?: string | undefined;
  currentLevel?: ContentLevel | null | undefined;
  contentMetadata?: Metadata[] | null | undefined;
  contentType: ContentType | undefined;
}) => {
  const { isTeacher, canSeeAiFeatures } = useGetUserProperties() || {};

  const isSupportedContent = isSupportedEnglishContent({
    articleType,
    contentType,
    currentLevel,
    contentMetadata,
  });

  return Boolean(isTeacher && isSupportedContent && canSeeAiFeatures);
};

export default useLessonPlannerVisibility;
